import type { Effect, Reducer, Subscription } from '@umijs/max';
import type { SingleUserAddressType } from './data';
import {
  addUserAddress,
  editUserAddress,
  getUserAddressPage,
  removeUserAddress,
} from './service';

export type UserAddressState = {
  code: number;
  type: string;
  message: string;
  total: number;
  current: number;
  pageSize: number;
  items: SingleUserAddressType[];
};

type UserAddressModelType = {
  namespace: string;
  state: UserAddressState;
  reducers: {
    UserAddressReducer: Reducer<UserAddressState>;
  };
  effects: {
    fetchUserAddressPageEffect: Effect;
    refreshDataEffect: Effect;
    addUserAddressEffect: Effect;
    editUserAddressEffect: Effect;
    removeUserAddressEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

// 通用操作处理函数
const createEffect = (serviceCall: any) =>
  function* (
    { payload: action, callback }: any,
    { call, put }: any,
  ): Generator<any, void, any> {
    try {
      const res: any = yield call(
        serviceCall,
        action.values || { id: action.id },
      );

      if (res && res.code === 0) {
        yield put({
          type: 'refreshDataEffect',
          payload: { ...action },
        });
      }

      callback?.(res);
    } catch (e) {}
  };

const UserAddressModel: UserAddressModelType = {
  namespace: 'userAddress',
  state: {
    code: 0,
    type: '',
    message: 'success',
    items: [],
    total: 0,
    pageSize: 20,
    current: 1,
  },

  reducers: {
    UserAddressReducer(state, action) {
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        items: payload.data?.items || [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as UserAddressState;
    },
  },

  effects: {
    *fetchUserAddressPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getUserAddressPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: 'UserAddressReducer',
          payload: res,
        });
      } catch (e) {
        console.error('Fetch data failed:', e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.userAddress.current);
      const pageSize = yield select((state: any) => state.userAddress.pageSize);
      yield put({
        type: 'fetchUserAddressPageEffect',
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },

    // 简化的 effects
    addUserAddressEffect: createEffect(addUserAddress),
    editUserAddressEffect: createEffect(editUserAddress),
    removeUserAddressEffect: createEffect(removeUserAddress),
  },

  subscriptions: {
    setup() {},
  },
};

export default UserAddressModel;
